export default __webpack_public_path__ + "static/media/icon_added_button.8e0afbb5.svg";